import { getAppData } from '../../lib/api/common';
import { getServicesPage } from '../../lib/api/services';

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import PageHeader from '../../components/content/page/PageHeader';
import Page from '../../components/content/page/Page'

import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";
// import ServicesOverview from '../../components/content/ServicesOverview';

export type HomeProps = {
	page: any
	// services: Array<any>
	app: any
}


export async function getStaticProps(context: any) {

	const app: any = await getAppData();
	const data: any = await getServicesPage(
		context.preview ? context.previewData?.token : undefined
	);

	return {
		props: {
			app: app ? app : null,
			page: data ? data.page : null,
			// services: data ? data.services : null,
		},
		revalidate: revalidateSeconds()
	};
}


export default function Home(props: HomeProps) {

	// const { page, services, app } = props
	const { page, app } = props

	// console.log('Services page props: ', props)

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={[
					{
						id: page.id,
						title: page.title,
						uri: null
					}
				]}
			>
				<>

					<Page page={page} />

					{/*<PageHeader page={page} />*/}
					{/* TODO - implement in CMS */}
					{/*<div className="section-header">
						<div className="section-header__wrapper">
							<div className="section-header__container">
								<h2>Introduction to services</h2>
								<p className='larger-text'>Mauris vitae metus vel orci scelerisque volutpat ut facilisis quam.</p>
								<p>Aliquam vel turpis mollis, elementum purus quis, fringilla enim. In hac habitasse platea dictumst. Curabitur mollis turpis id porta ornare. Aenean lorem tellus, maximus id elit sed, tempor tristique justo.</p>
							</div>
						</div>
					</div>

					<ServicesOverview services={services} />*/}

				</>
			</Layout>
		</>
	)
}

